import { useMemo } from 'react';
const useIconVariation = _ref => {
  let {
    size = 24,
    icons
  } = _ref;
  return useMemo(() => icons.map(icon => {
    if (icon._16 && size <= 16) return icon._16;
    return icon._24;
  }), [size, icons]);
};
export default useIconVariation;
//# sourceMappingURL=useIconVariation.js.map